import { render } from "./Input.vue?vue&type=template&id=48c1dde8&scoped=true"
import script from "./Input.vue?vue&type=script&lang=ts"
export * from "./Input.vue?vue&type=script&lang=ts"

import "./Input.vue?vue&type=style&index=0&id=48c1dde8&lang=sass&scoped=true"
script.render = render
script.__scopeId = "data-v-48c1dde8"

export default script